import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import "firebase/auth";
import { LngLatBounds } from "mapbox-gl";
import { ApiResponse } from "@/util/types";

export class CloudFunctionApis {
  private baseUrl: string;

  constructor() {
    this.baseUrl = "https://us-central1-travelapp-dd0fd.cloudfunctions.net/";
  }

  private makeGet(
    functionName: string,
    params?: Object
  ): Promise<AxiosResponse<ApiResponse>> {
    return axios.get(`${this.baseUrl}${functionName}`, {
      params
    });
  }

  private async makePost(
    functionName: string,
    params?: Object
  ): Promise<AxiosResponse<ApiResponse>> {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("user must be logged in");
    }

    const idToken = await currentUser.getIdToken(/* forceRefresh */ true);
    return axios.post(
      `${this.baseUrl}${functionName}`,
      {
        params
      },
      {
        headers: {
          Authorization: "Bearer " + idToken
        }
      }
    );
  }

  getPopularPhotos(bounds: LngLatBounds, page: number, search?: string) {
    return this.makeGet("popularPhotos", {
      north: bounds.getNorth(),
      south: bounds.getSouth(),
      west: bounds.getWest(),
      east: bounds.getEast(),
      page,
      search
    });
  }

  // @TODO check this by logged in userId
  // getLikedPhotosList() {
  //    return this.makeGet("likedPhotosList");
  // }

  likePhoto(imageId: string) {
    return this.makePost("likePhoto", {
      photoId: imageId
    });
  }

  unlikePhoto(imageId: string) {
    return this.makePost("unlikePhoto", {
      photoId: imageId
    });
  }

  // @TODO Update this accordingly when the endpoint is finished
  uploadImages(images: Object) {
    return this.makePost("uploadImages", {
      images
    })
  }
}
